import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"
import styles from "./header.css"

const Header = ({ siteTitle }) => (
  <header
    className="navbar-container">
    <div className="navbar gray">
      <div className="navbar-icon tooltip">
        <Link to="/">
          <i className="fas fa-home"></i>
        </Link>
        <span className="tooltiptext">Home</span>
      </div>
      <div className="navbar-icon tooltip">
        <Link to="/projects">
          <i className="fas fa-folder"></i>
        </Link>
        <span className="tooltiptext">Projects</span>
      </div>
      <div className="navbar-icon tooltip">
        <Link to="/blogs">
          <i className="fas fa-book"></i>
        </Link>
        <span className="tooltiptext">Blogs</span>
      </div>
      <div className="navbar-icon tooltip">
        <Link to="/about">
          <i className="fas fa-info-circle"></i>
        </Link>
        <span className="tooltiptext">About</span>
      </div>
      <div className="navbar-icon tooltip">
        <Link to="/contact">
          <i className="fas fa-at"></i>
        </Link>
        <span className="tooltiptext">Hire Me</span>
      </div>
    </div>
  </header>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
